var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgReset = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 14.897 }, props, { children: _jsx("path", { "data-name": "Path 125", d: "M10.552 14.9A7.448 7.448 0 1 0 3.1 7.448V11.3L.869 9.062 0 9.931l3.724 3.724 3.724-3.724-.869-.869L4.345 11.3V7.448a6.207 6.207 0 1 1 6.207 6.207Z" }) }))); };
export default SvgReset;
